import type { ImportDefinitionContract } from '@today/types'
import { Button } from '@today/ui-primitives'

/**
 * Props for {@link ContractJsonView}.
 *
 * @property contract - The contract the designer will save.
 * @property onCopy - Called with the JSON text when Copy is pressed.
 */
export interface ContractJsonViewProps {
	contract: ImportDefinitionContract
	onCopy?: (json: string) => void
}

/** The exact contract that Save sends, as JSON (TO-400 BR-12). Read-only. Pure. */
export function ContractJsonView({ contract, onCopy }: ContractJsonViewProps) {
	const json = JSON.stringify(contract, null, 2)
	return (
		<div className="flex flex-col gap-2">
			{onCopy && (
				<Button variant="secondary" size="sm" onPress={() => onCopy(json)}>
					Copy JSON
				</Button>
			)}
			<section aria-label="Contract JSON">
				<pre className="max-h-96 overflow-auto rounded-ds-control bg-ds-surface-muted p-ds-3 font-mono text-ds-sm text-ds-text">
					{json}
				</pre>
			</section>
		</div>
	)
}
